import {Grid} from '@mui/material';
import React from 'react';
import {useSepsisFromStyles} from '../sepsisPathwayForm';
import SepsisPathwaySelect from './sepsisPathwaySelect';

const SepsisPathwayFormRowPaed = ({sepsisField, sepsisPathwayObj, setSepsisPathwayField, canEditSepsis}) => {
    const classes = useSepsisFromStyles();

    return (
        <div className={classes.sepsisRow}>
            <Grid container alignItems="center" className={classes.reassessRow}>
                <Grid item xs={10}>
                    <Grid container alignItems="stretch">
                        {sepsisField.number > 0 &&
                            <div className={classes.pathNumber}>
                                {sepsisField.number}
                            </div>
                        }

                        <div className={classes.subjectBox}>
                            {sepsisField.subject &&
                                <div className={classes.subject}>
                                    {sepsisField.subject}
                                </div>
                            }
                        </div>
                    </Grid>
                </Grid>

                <Grid item xs={2}>
                    <SepsisPathwaySelect
                        sepsisField={sepsisField}
                        sepsisPathwayObj={sepsisPathwayObj}
                        canEditSepsis={canEditSepsis}
                        setSepsisPathwayField={setSepsisPathwayField}
                        isPaeds
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default SepsisPathwayFormRowPaed;